import Api from "./axios";

const api = new Api();

export const uploadSertifikat = async (datas) => {
    try {
        let data = await api.post("/files/upload", datas, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
        return data;
    } catch (error) {
        console.error(error);
        return false;
    }
};

export const createAcmt = async (datas) => {
    try {
        let data = await api.post("/prestasi/create", datas, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        return data;
    } catch (error) {
        console.error(error);
        return false;
    }
};

export const updateAcmt = async (datas) => {
    try {
        let data = await api.post("/prestasi/update", datas, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        return data;
    } catch (error) {
        console.error(error);
        return false;
    }
};

export const updateCert = async (datas) => {
    try {
        let data = await api.patch("/files/update", datas, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
        return data;
    } catch (error) {
        console.error(error);
        return false;
    }
};

export const deleteAcmt = async (id, certificate_file) => {
    try {
        let data = await api.post(
            "/prestasi/delete",
            {
                id,
                certificate_file,
            },
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );
        return data;
    } catch (error) {
        console.error(error);
        return false;
    }
};

export const importAcmt = async (datas) => {
    try {
        let data = await api.post("/data/achievement/import", datas, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
        return data;
    } catch (error) {
        console.error(error);
        return false;
    }
};

export const getAllAcmt = async () => {
    try {
        let data = await api.get("/prestasi");
        return data;
    } catch (error) {
        console.error(error);
        return false;
    }
};
